import React, { Component } from 'react'
import { Layout, PageTitle, Container } from 'src/components/Layout'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'
import List from 'src/components/List'

import { injectIntl } from 'react-intl'
import { getCurrentPageUrlInfo } from 'src/utils/helpers'
import ChangeLanguage from 'src/modals/ChangeLanguage/index'

class Auth extends Component {
  state = {
    showChangeLanguageModal: false,
  }
  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
    const { setAppActionsDisabledState } = this.props
    setAppActionsDisabledState(false)
  }

  render() {
    const { location, history, areAppActionsDisabled, language } = this.props

    const items = [
      {
        leftIcon: ['far', 'globe'],
        name: 'Language',
        id: 'language',
        description: language === 'en' ? 'English' : 'Français',
        onClick: () => {
          this.setState({ showChangeLanguageModal: true })
        },
      },

      {
        leftIcon: ['far', 'right-from-bracket'],
        hideArrowAlways: true,
        name: 'Login',
        onClick: () => {
          history.push('/auth/login')
        },
      },
    ]

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

    const isChatPage = currentPageUrl === '/chat'

    return (
      <Layout>
        <PageTitle title={'Profile'} />
        <Container>
          <Box px={{ base: '20px', lg: 0 }} my={{ md: '0', lg: '20px' }}>
            <List
              items={items}
              isProfile={true}
              noMargin={true}
              preventActiveState={isChatPage}
              areAppActionsDisabled={areAppActionsDisabled}
            />
          </Box>
          <ChangeLanguage
            visible={this.state.showChangeLanguageModal}
            onClose={() => this.setState({ showChangeLanguageModal: false })}
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(Auth)
